const NAME = 'preview';

export const FETCH_PREVIEW_BLOCK_RECEIVED = `${NAME}/_PREVIEW_RECEIVED`;
